export default __webpack_public_path__ + "static/build-and-engineer-f3d28e46f5b28f1d2d00a795956c16f0.jpg";